<div class="header row">
    <div class="col-12">
        <h2><strong>Clienti</strong></h2>
        <div *ngIf="false" class="breadcrumb-wrapper hidden-xs">
            <ol class="breadcrumb">
                <li class="active">Clienti</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content">
                <div *ngIf="customers!.length > 0; else customersEmpty">
                    <ng-container *ngIf="(customers
                          | advancedSearchFilter: advancedFields: advancedState
                          | customerGlobalSearchFilter: globalSearchFilterValue
                          | customerIdFilter: idFilterValue
                          | customerCreationDateFilter: creationDateFromFilterValue: creationDateToFilterValue
                          | customerCompanyNameFilter: companyNameFilterValue
                          | customerVatNumberFilter: vatNumberFilterValue
                          | customerEmailFilter: emailFilterValue
                          | customerCityFilter: cityFilterValue
                          | customerMobilePhoneFilter: mobilePhoneFilterValue
                          | customerEnabledFilter: enabledFilterValue) as filteredCustomers">
                        <app-preset-filters [presets]="presets"
                                            [activeId]="activePreset"
                                            [counts]="presetCounts"
                                            (selected)="applyPreset($event)"></app-preset-filters>

                        <app-advanced-search [fields]="advancedFields"
                                             [state]="advancedState"
                                             (stateChange)="onAdvancedStateChange($event)"></app-advanced-search>

                        <div class="dashboard-toolbar">
                            <div class="toolbar-left">
                                <label for="items-per-page">Mostra</label>
                                <input [(ngModel)]="paginationConfig.itemsPerPage"
                                       (change)="paginationConfig.currentPage = 1"
                                       class="form-control input-sm form-white items-per-page-input"
                                       id="items-per-page"
                                       name="items-per-page"
                                       type="number">
                                <span class="results-count">
                                    di {{ filteredCustomers.length }}
                                    {{ filteredCustomers.length === 1 ? 'cliente' : 'clienti' }}
                                </span>
                                <button *ngIf="hasActiveFilters()"
                                        type="button"
                                        class="btn btn-link btn-sm clear-filters-link"
                                        (click)="clearFilters()">
                                    Pulisci filtri
                                </button>
                            </div>

                            <div class="toolbar-center">
                                <span class="date-filter-label">Data creazione</span>
                                <label class="date-filter-field" for="creation-date-from">
                                    <span>Da</span>
                                    <input [(ngModel)]="creationDateFromFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="date"
                                           class="form-control form-white"
                                           id="creation-date-from"
                                           name="creation-date-from">
                                </label>
                                <label class="date-filter-field" for="creation-date-to">
                                    <span>A</span>
                                    <input [(ngModel)]="creationDateToFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="date"
                                           class="form-control form-white"
                                           id="creation-date-to"
                                           name="creation-date-to">
                                </label>
                            </div>

                            <div class="toolbar-right">
                                <button type="button"
                                        class="btn btn-sm btn-secondary export-csv-btn"
                                        [disabled]="filteredCustomers.length === 0"
                                        (click)="exportCsv(filteredCustomers)"
                                        title="Esporta in CSV i clienti filtrati">
                                    <i class="fa fa-download" style="margin-right: 7px;"></i>CSV
                                </button>
                                <a (click)="openCreateCustomerModal()"
                                   class="edit btn btn-sm btn-primary">
                                    <i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuovo Cliente
                                </a>
                            </div>
                        </div>

                        <div class="row mobile-search-row">
                            <div class="col-xs-12">
                                <div class="form-group prepend-icon">
                                    <input [(ngModel)]="globalSearchFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="text"
                                           class="form-control form-white"
                                           id="mobile-global-search"
                                           name="mobile-global-search"
                                           placeholder="Cerca ID, nome, P.IVA, email, città, cellulare...">
                                    <i class="icon-magnifier"></i>
                                </div>
                            </div>
                        </div>

                        <ng-template #notFilled>
                            <span class="not-filled-placeholder" title="Il cliente non ha ancora compilato questo dato">Da compilare</span>
                        </ng-template>

                        <div class="table-container table-scroll">
                            <table class="table table-hover table-customer" [appStableColumns]="columnLayoutToken">
                                <thead>
                                <tr class="column-titles">
                                    <th *ngIf="isColumnVisible('id')" class="col-id">ID Cliente</th>
                                    <th *ngIf="isColumnVisible('creationDate')">Data Creazione</th>
                                    <th *ngIf="isColumnVisible('name')" class="col-flex">Ragione Sociale / Nominativo</th>
                                    <th *ngIf="isColumnVisible('vat')">Partita IVA</th>
                                    <th *ngIf="isColumnVisible('email')">Email</th>
                                    <th *ngIf="isColumnVisible('city')">Città</th>
                                    <th *ngIf="isColumnVisible('mobile')">Cellulare</th>
                                    <th *ngIf="isColumnVisible('completed')" class="text-center" title="Pratiche concluse (stato Completato)">Pratiche completate</th>
                                    <th *ngIf="isColumnVisible('status')" class="status-filter-col">Stato</th>
                                    <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                                </tr>
                                <tr class="column-filters hidden-xs hidden-sm">
                                    <th *ngIf="isColumnVisible('id')" class="col-id">
                                        <input [(ngModel)]="idFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="ID"
                                               aria-label="Filtra per ID cliente">
                                    </th>
                                    <th *ngIf="isColumnVisible('creationDate')"></th>
                                    <th *ngIf="isColumnVisible('name')" class="col-flex">
                                        <input [(ngModel)]="companyNameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Nome"
                                               aria-label="Filtra per ragione sociale o nominativo">
                                    </th>
                                    <th *ngIf="isColumnVisible('vat')">
                                        <input [(ngModel)]="vatNumberFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="P.IVA"
                                               aria-label="Filtra per partita IVA">
                                    </th>
                                    <th *ngIf="isColumnVisible('email')">
                                        <input [(ngModel)]="emailFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Email"
                                               aria-label="Filtra per email">
                                    </th>
                                    <th *ngIf="isColumnVisible('city')">
                                        <input [(ngModel)]="cityFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Città"
                                               aria-label="Filtra per città">
                                    </th>
                                    <th *ngIf="isColumnVisible('mobile')">
                                        <input [(ngModel)]="mobilePhoneFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Cell."
                                               aria-label="Filtra per cellulare">
                                    </th>
                                    <th *ngIf="isColumnVisible('completed')"></th>
                                    <th *ngIf="isColumnVisible('status')" class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="enabled-filter"
                                                    aria-label="Filtra per stato"
                                                    [title]="getEnabledFilterLabel()">
                                                <span class="status-filter-label">{{ getEnabledFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Stati cliente">
                                                <label *ngFor="let status of enabledOptions"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isEnabledSelected(status)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onEnabledToggle(status, $event)">
                                                    <span>{{ status }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="col-sticky col-sticky-actions"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngIf="filteredCustomers.length === 0">
                                    <td [attr.colspan]="visibleColumnCount" class="filtered-empty-state">
                                        <div class="filtered-empty-pin">
                                            <p>Nessun risultato con i filtri attuali.</p>
                                            <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">Pulisci filtri</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let customer of filteredCustomers | paginate: paginationConfig">
                                    <td *ngIf="isColumnVisible('id')" class="col-id" (click)="goToCustomerDetail(customer.IDCustomer)">{{ customer.IDCustomer }}</td>

                                    <td *ngIf="isColumnVisible('creationDate')" (click)="goToCustomerDetail(customer.IDCustomer)">
                                        {{ customer.CreationDate ? (customer.CreationDate | date: 'dd/MM/yyyy HH:mm') : '-' }}
                                    </td>

                                    <td *ngIf="isColumnVisible('name')" (click)="goToCustomerDetail(customer.IDCustomer)">
                                        <ng-container *ngIf="customer.CompanyName?.trim(); else personName">{{ customer.CompanyName }}</ng-container>
                                        <ng-template #personName>
                                            <ng-container *ngIf="(customer.Name || customer.Surname)?.trim(); else notFilled">{{ customer.Name }} {{ customer.Surname }}</ng-container>
                                        </ng-template>
                                    </td>

                                    <td *ngIf="isColumnVisible('vat')" (click)="goToCustomerDetail(customer.IDCustomer)">
                                        <ng-container *ngIf="customer.VATNumber?.trim(); else notFilled">{{ customer.VATNumber }}</ng-container>
                                    </td>
                                    <td *ngIf="isColumnVisible('email')"
                                        class="col-email"
                                        (click)="goToCustomerDetail(customer.IDCustomer)"
                                        [title]="customerEmailsLabel(customer)">
                                        <div *ngIf="customerEmailList(customer).length > 0; else notFilled" class="customer-email-list">
                                            <span *ngFor="let email of customerEmailList(customer)" class="customer-email-badge">
                                                <i class="fa fa-envelope-o customer-email-badge-icon" aria-hidden="true"></i>
                                                <span class="customer-email-badge-text">{{ email }}</span>
                                            </span>
                                        </div>
                                    </td>
                                    <td *ngIf="isColumnVisible('city')" (click)="goToCustomerDetail(customer.IDCustomer)">
                                        <ng-container *ngIf="(customer.HeadOffice?.trim() || customer.City?.trim()); else notFilled">{{ customer.HeadOffice?.trim() || customer.City }}</ng-container>
                                    </td>
                                    <td *ngIf="isColumnVisible('mobile')" (click)="goToCustomerDetail(customer.IDCustomer)">
                                        <ng-container *ngIf="customer.MobilePhone?.trim(); else notFilled">{{ customer.MobilePhone }}</ng-container>
                                    </td>

                                    <td *ngIf="isColumnVisible('completed')" class="text-center" (click)="goToCustomerDetail(customer.IDCustomer)">
                                        <span class="completed-count" [class.completed-count--zero]="!customer.CompletedRequestsCount">
                                            <i class="fa fa-trophy" aria-hidden="true"></i>{{ customer.CompletedRequestsCount || 0 }}
                                        </span>
                                    </td>

                                    <td *ngIf="isColumnVisible('status')" (click)="goToCustomerDetail(customer.IDCustomer)">
                                        <span *ngIf="customer.Enabled" class="badge badge-success">Attivo</span>
                                        <span *ngIf="!customer.Enabled" class="badge badge-secondary">Disabilitato</span>
                                    </td>

                                    <td class="text-right col-sticky col-sticky-actions">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="btn-group">
                                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                                                Azioni
                                            </button>
                                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right row-actions-menu">
                                                <a [routerLink]="['/clienti/modifica/' + customer.IDCustomer]" class="dropdown-item" type="button"><i class="fa fa-pencil"></i>Modifica</a>
                                                <button *ngIf="customer.Enabled" (click)="openToggleEnabledModal(customer)" class="dropdown-item" type="button"><i class="fa fa-ban"></i>Disabilita</button>
                                                <button *ngIf="!customer.Enabled" (click)="openToggleEnabledModal(customer)" class="dropdown-item" type="button"><i class="fa fa-check"></i>Riattiva</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <pagination-controls *ngIf="filteredCustomers.length > 0"
                                             (pageChange)="pageChanged($event)"
                                             [autoHide]="paginationParams.autoHide"
                                             [maxSize]="paginationParams.maxSize"
                                             [responsive]="paginationParams.responsive"
                                             [previousLabel]="paginationLabels.previousLabel"
                                             [nextLabel]="paginationLabels.nextLabel"
                                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                        ></pagination-controls>
                    </ng-container>
                </div>
                <ng-template #customersEmpty>
                    <div>
                        <div class="row">
                            <div class="col-md-3 col-md-offset-9 col-xs-12" style="text-align: right;">
                                <a (click)="openCreateCustomerModal()" class="edit btn btn-sm btn-primary"><i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuovo Cliente</a>
                            </div>
                        </div>
                        <div style="height: 200px; text-align: center; padding-top: 85px;">
                            Nessun cliente trovato.
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
